import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { Mail, Eye, EyeOff, AlertTriangle, Loader2, ArrowLeft } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg, #0a2e0a 0%, #1a5c1a 50%, #0d3d0d 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, position:'relative', overflow:'hidden' }}>
      {/* Background pattern — now with pointerEvents: 'none' so it doesn't block clicks */}
      <div style={{ position:'absolute', inset:0, opacity:0.04, backgroundImage:'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize:'28px 28px', pointerEvents: 'none' }} />

      <div style={{ width:'100%', maxWidth:420, animation:'fadeInUp 0.5s ease', position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:60, height:60, background:'linear-gradient(135deg, #2d8a2d, #0d4a0d)', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', color:'#f5a623', fontWeight:900, fontSize:'1.1rem', margin:'0 auto 12px', boxShadow:'0 8px 24px rgba(0,0,0,0.3)' }}>ZAN</div>
          <h1 style={{ color:'white', fontFamily:"'Inter',sans-serif", fontSize:'1.4rem', fontWeight:800, marginBottom:4 }}>Zim CSO Database</h1>
          <p style={{ color:'rgba(255,255,255,0.5)', fontSize:'0.82rem' }}>Staff Administration Portal</p>
        </div>

        {/* Card */}
        <div className="card" style={{ padding:32 }}>
          <h2 style={{ fontSize:'1.1rem', fontWeight:700, marginBottom:4 }}>Sign in to your account</h2>
          <p style={{ color:'var(--gray-500)', fontSize:'0.82rem', marginBottom:24 }}>Enter your credentials to access the admin panel</p>

          {error && (
            <div className="alert alert-error" style={{ marginBottom:16, display:'flex', alignItems:'center', gap:8 }}>
              <AlertTriangle size={16} /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <div className="input-group">
                <span className="input-icon"><Mail size={16} /></span>
                <input type="email" className="form-control" required placeholder="you@zimcsodatabase.org"
                  value={form.email} onChange={e => setForm({...form, email:e.target.value})}/>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position:'relative' }}>
                <input type={show?'text':'password'} className="form-control" required placeholder="••••••••"
                  value={form.password} onChange={e => setForm({...form, password:e.target.value})}
                  style={{ paddingRight:40 }}/>
                <button type="button" onClick={() => setShow(!show)}
                  style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--gray-400)', padding:0, display:'flex' }}>
                  {show ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn btn-primary"
              style={{ width:'100%', justifyContent:'center', padding:12, marginTop:8, fontSize:'0.9rem', display:'flex', alignItems:'center', gap:8, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? <><Loader2 size={18} className="spin" /> Signing in...</> : 'Sign In'}
            </button>
          </form>
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <Link to="/" style={{ color:'rgba(255,255,255,0.5)', fontSize:'0.8rem', display:'inline-flex', alignItems:'center', gap:4, textDecoration: 'none', cursor: 'pointer' }}>
            <ArrowLeft size={14} /> Back to Public Site
          </Link>
        </div>
      </div>
    </div>
  );
}